"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBorrowingBaseAvailability = exports.getMaxFundingAvailability = exports.getMaxRecycle = void 0;
const common_1 = require("@finley-technologies/common");
const borrowingBase_1 = require("../borrowingBase");
const getMaxRecycle = ({ cashBalances, cashReserveAmount, }) => {
    const collectionsAccountCash = cashBalances.reduce((acc, cashBalance) => {
        if (cashBalance.accountType === 'collections') {
            return acc + (cashBalance.balance || 0);
        }
        return acc;
    }, 0);
    const maxRecycle = common_1.utils.jsRound({
        value: collectionsAccountCash - cashReserveAmount,
        precision: 2,
    });
    // return maxRecycle in 2 decimal places
    return Math.floor(maxRecycle * 100) / 100;
};
exports.getMaxRecycle = getMaxRecycle;
const getMaxFundingAvailability = ({ receivableAdvance, cashAdvance, outstandingBalance, isStopDrawEnforced, }) => {
    if (cashAdvance < 0 && isStopDrawEnforced) {
        return 0;
    }
    // There are other missing strategies here surrounding receivable deficiency that is covered by cash
    return common_1.utils.jsRound({
        value: receivableAdvance + cashAdvance - outstandingBalance,
        precision: 2,
    });
};
exports.getMaxFundingAvailability = getMaxFundingAvailability;
// Allows for recalculation after accounting for recycle
const getBorrowingBaseAvailability = ({ outstandingBalance, receivableAdvance, cashBalances, borrowingBaseReserveAmount, recycleRequest, isStopDrawEnforced, }) => {
    const adjustedCashBalances = cashBalances.map((cashBalance) => {
        if (cashBalance.accountType === 'collections') {
            return {
                ...cashBalance,
                balance: cashBalance.balance - (recycleRequest ?? 0),
            };
        }
        return { ...cashBalance };
    });
    const { totalCashBorrowingBaseAmount, } = (0, borrowingBase_1.calculateBorrowingBaseKeyCashAttributes)(adjustedCashBalances, {
        borrowingBaseReserveAmount,
        isBorrowingBaseReservePositiveExcessCollectionsOverReserve: false,
    });
    const availability = (0, exports.getMaxFundingAvailability)({
        receivableAdvance,
        cashAdvance: totalCashBorrowingBaseAmount,
        outstandingBalance,
        isStopDrawEnforced,
    });
    return availability;
};
exports.getBorrowingBaseAvailability = getBorrowingBaseAvailability;
//# sourceMappingURL=calculation.js.map